import { _2dMapCombinedQuote, _2dMapQuote } from '@larki/shared/type/order.v2';

export const TypeIconMap = {
  file: 'clip',
  order: 'shopping-cart',
  note: 'speech',
  user: 'user-outline',
  alert: 'larki-icon',
  status: '?',
};

export function toCombinedQuote(
  data: _2dMapCombinedQuote | _2dMapQuote
): _2dMapCombinedQuote {
  if ('nonRfq' in data) return data;
  const emptyRfq: _2dMapQuote = {
    composition: {},
    totals: data.totals,
    currency: data.currency,
  };
  return {
    nonRfq: data,
    rfq: emptyRfq,
    totals: data.totals,
    currency: data.currency,
  };
}
